import React, { useEffect, useRef, useState } from 'react'

import { Tooltip } from 'components/Tooltip'
import { select } from 'd3-selection'
import './styles.scss'
import { Chart } from 'components/Chart'
import { parseText } from 'components/_utils'
import useDimensions from './useDimensions'
import { Waypoint } from 'react-waypoint'
import SVG, { Props as SVGProps } from 'react-inlinesvg'

const DRAWPROP = 'newCasesPop'

export const Country = ({
  data,
  colorkeydata,
  maponly = false,
  setCurrent
}: {
  data: countryElement
  colorkeydata: [string[], string[]]
  maponly?: boolean
  setCurrent?: React.Dispatch<React.SetStateAction<string>>
}) => {
  const [ttpos, setttpos] = useState<
    [number, number, dataElement] | undefined
  >()
  const [countryData, setCountryData] = useState<dataPoint[][]>()
  const [REF, size, Node] = useDimensions()
  const SVGEL = useRef()
  // const [totals, setTotals] = useState<[number, number]>([0, 0])
  const colorgradient = colorkeydata[1].map(
    (m, i) => m + ' ' + (100 / (colorkeydata[1].length - 1)) * i + '%'
  )

  useEffect(() => {
    let countries = ['CH', data.country]
    let files = countries.map(code => {
      return fetch(
        `https://ta-interaktiv.storage.googleapis.com/corona-dashboard/countries_date/${code}.json?a=` +
          Math.random()
      )
        .then(response => response.json())
        .catch(error => console.warn(error))
    })

    Promise.all(files).then((results: { [key: string]: dataPoint[] }[]) => {
      setCountryData([results[0][DRAWPROP], results[1][DRAWPROP]])
    })
  }, [data.name])

  const {
    name,
    country,
    subnational,
    main,
    block1,
    block1title,
    block2,
    block2title,
    block3,
    block3title,
    block4,
    block4title
  } = data
  // const Map = Countries[country]
  const handleWaypointEnter = (e, which) => {
    let what = 'enter'
    if (e.currentPosition == 'inside' && e.previousPosition === 'below') {
      what = 'enter_from_bottom'
      if (which === 'top' && setCurrent) {
        setCurrent(country)
      }
    }
    if (e.currentPosition == 'inside' && e.previousPosition === 'above') {
      what = 'enter_from_top'
      if (which === 'bottom' && setCurrent) {
        setCurrent(country)
      }
    }
  }
  return (
    <>
      <div className='' style={{ marginTop: maponly ? '0' : '90px' }}>
        <Waypoint
          onEnter={e => {
            handleWaypointEnter(e, 'top')
          }}
        />
        <a
          id={country}
          style={{
            display: 'block',
            position: 'relative',
            top: '-25px',
            visibility: 'hidden'
          }}
        />{' '}
        <div className={'countrytitle ' + (maponly ? 'noborder' : '')}>
          {name}
        </div>
        {subnational && (
          <div className='mapholder'>
            <div className='mapwrapper' ref={REF}>
              <SVG
                src={require('./' + country + '.svg')}
                uniquifyIDs={false}
                id='EUSVG'
                innerRef={SVGEL}
                onLoad={svgel => {
                  if (!SVGEL.current) return
                  const noprov = [
                    '_RS001',
                    '_ME',
                    '_LU',
                    '_AD',
                    '_LI',
                    '_BY',
                    '_IS',
                    '_MT'
                  ]

                  let svg = select(SVGEL.current).attr('class', 'Country')
                  svg
                    .selectAll('path')
                    .attr('fill', 'none')
                    .attr('stroke-width', 0.3)
                    .attr('stroke', '#fff')
                  subnational.forEach((element: dataElement) => {
                    let el

                    if (country !== 'EU') {
                      el = svg.select('.' + element.id)
                    } else {
                      el = svg.select('.' + ('_' + element.id))
                    }

                    el.attr('fill', element.color)
                      .on('mousemove', e =>
                        setttpos([e.layerX, e.layerY, element])
                      )
                      .on('mouseout', e => setttpos(undefined))
                  })
                  svg.selectAll('path').each(function() {
                    let el = select(this)
                    if ((el.attr('class') || '').length < 4) {
                      if (noprov.indexOf(el.attr('class')) === -1) {
                        el.attr('stroke-width', 2)
                      }
                    }
                  })
                }}
              />

              {ttpos && (
                <Tooltip
                  pos={{ x: ttpos[0], y: ttpos[1] }}
                  data={ttpos[2]}
                  parentsize={size}
                />
              )}
            </div>
            {subnational && (
              <div className='factwrapper'>
                <div className='colorkey'>
                  <div className='title'>7-Tage-Inzidenz</div>
                  <div className='sub'>
                    Best. Fälle letzte 7 Tage pro 100'000 Personen
                  </div>
                  <div className='swatchholder'>
                    {colorkeydata[0].slice(0, 7).map((m, i) => {
                      let text = '<' + colorkeydata[0][i]
                      if (i === 6)
                        text = '>' + colorkeydata[0][colorkeydata[0].length - 2]
                      return (
                        <div
                          className='entry'
                          style={{
                            backgroundColor: colorkeydata[1][i],
                            color: i < 2 ? undefined : '#fff'
                          }}
                        >
                          <div className='value'>{text}</div>{' '}
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {!maponly && (
          <div className='ui text container'>
            <div className='ta text'>
              <div className='countrytext'>
                <>
                  <p>{parseText(main)}</p>
                  {countryData && (
                    <Chart countryData={countryData} country={name} />
                  )}

                  {block1 && block1title && (
                    <p
                      className={
                        'fact ' + (!block2 || !block2title ? 'fw' : '')
                      }
                    >
                      <span className='blocktitle'>{block1title}</span>
                      {parseText(block1)}
                    </p>
                  )}
                  {block2 && block2title && (
                    <p
                      className={
                        'fact ' + (!block1 || !block1title ? 'fw' : '')
                      }
                    >
                      <span className='blocktitle'>{block2title}</span>{' '}
                      {parseText(block2)}
                    </p>
                  )}

                  {block3 && block3title && (
                    <p
                      className={
                        'fact ' + (!block4 || !block4title ? 'fw' : '')
                      }
                    >
                      <span className='blocktitle'>{block3title}</span>{' '}
                      {parseText(block3)}
                    </p>
                  )}

                  {block4 && block4title && (
                    <p
                      className={
                        'fact ' + (!block3 || !block3title ? 'fw' : '')
                      }
                    >
                      <span className='blocktitle'>{block4title}</span>
                      {parseText(block4)}
                    </p>
                  )}
                </>
              </div>
            </div>
          </div>
        )}
        <Waypoint
          onEnter={e => {
            handleWaypointEnter(e, 'bottom')
          }}
          topOffset={'300px'}
        />
      </div>
    </>
  )
}
